import { Rectangle } from "../../maths/Rectangle";
import { genSliceMesh } from "../mesh/MeshFactory";
import { ClassUtils } from "../../utils/ClassUtils";
import { ColorUtils } from "../../utils/ColorUtils";
import { Pool } from "../../utils/Pool";
import { VertexStream } from "../../utils/VertexStream";
import { Config } from "../../../Config";
import { UVClippingUtils } from "../../webgl/utils/UVClippingUtils";
import { drawTrianglesBatched } from "./DrawTrianglesBatchHelper";
const className = "Draw9GridTextureCmd";
export class Draw9GridTextureCmd {
    constructor() {
        this.x = 0;
        this.y = 0;
        this.width = 1;
        this.height = 1;
        this.color = 0xffffffff;
        this.percent = true;
    }
    static create(texture, x, y, width, height, sizeGrid, percent, color) {
        let cmd = Pool.getItemByClass(className, Draw9GridTextureCmd);
        cmd.texture = texture;
        texture._addReference();
        cmd.x = x;
        cmd.y = y;
        cmd.width = width;
        cmd.height = height;
        cmd.sizeGrid = sizeGrid;
        cmd.percent = percent;
        cmd.color = color != null ? ColorUtils.create(color).numColor : 0xffffffff;
        return cmd;
    }
    recover() {
        var _a;
        (_a = this.texture) === null || _a === void 0 ? void 0 : _a._removeReference();
        this.texture = null;
        Pool.recover(className, this);
    }
    run(runner, gx, gy) {
        if (this.texture) {
            let sizeGrid = this.sizeGrid || this.texture._sizeGrid || EMPTY_SIZE_GRID;
            let x = this.x;
            let y = this.y;
            let w = this.width;
            let h = this.height;
            if (this.percent && runner.sprite) {
                x *= runner.sprite.width;
                y *= runner.sprite.height;
                w *= runner.sprite.width;
                h *= runner.sprite.height;
            }
            let vb = VertexStream.pool.take(this.texture);
            vb.contentRect.setTo(0, 0, w, h);
            if (this.color)
                vb.color.setABGR(this.color);
            let gridRect = Rectangle.create();
            let sourceWidth = vb.mainTex.sourceWidth;
            let sourceHeight = vb.mainTex.sourceHeight;
            gridRect.setTo(sizeGrid[3], sizeGrid[0], sourceWidth - sizeGrid[1] - sizeGrid[3], sourceHeight - sizeGrid[0] - sizeGrid[2]);
            genSliceMesh(vb, vb.contentRect, vb.uvRect, gridRect, sizeGrid[4] === 1 ? 0xff : 0);
            if (this.texture.uvrect) {
                if (Config.uvClipMode === "cpu") {
                    const clippedData = UVClippingUtils.clipTrianglesByUVRange(vb.getVertices(), vb.getIndices(), vb.getUVs(), this.texture.uvrect, vb.getColors());
                    drawTrianglesBatched(runner, this.texture, x + gx, y + gy, clippedData.vertices, clippedData.uvs, clippedData.indices, null, 1, null, null, clippedData.colors, null);
                }
                else {
                    drawTrianglesBatched(runner, this.texture, x + gx, y + gy, vb.getVertices(), vb.getUVs(), vb.getIndices(), null, 1, null, null, vb.getColors(), this.texture.uvrect);
                }
            }
            else {
                drawTrianglesBatched(runner, this.texture, x + gx, y + gy, vb.getVertices(), vb.getUVs(), vb.getIndices(), null, 1, null, null, vb.getColors(), null);
            }
            VertexStream.pool.recover(vb);
        }
    }
    get cmdID() {
        return Draw9GridTextureCmd.ID;
    }
    needsLayoutRepaint() {
        return this.percent ? 1 : 0;
    }
    getBounds(assembler) {
        let rect = Rectangle.TEMP.setTo(this.x, this.y, this.width, this.height);
        if (this.percent) {
            rect.scale(assembler.width, assembler.height);
        }
        rect.getBoundPoints(assembler.points);
    }
}
Draw9GridTextureCmd.ID = className;
const EMPTY_SIZE_GRID = [0, 0, 0, 0, 0];
ClassUtils.regClass(className, Draw9GridTextureCmd);
